/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscreate1Inputs */

const en_partnerscreate1 = /** @type {(inputs: Partnerscreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add partner`)
};

const de_partnerscreate1 = /** @type {(inputs: Partnerscreate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner anlegen`)
};

/**
* | output |
* | --- |
* | "Add partner" |
*
* @param {Partnerscreate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscreate1 = /** @type {((inputs?: Partnerscreate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscreate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscreate1(inputs)
	return de_partnerscreate1(inputs)
});
export { partnerscreate1 as "partnersCreate" }